/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { css } from 'styled-components';

import { icons } from '../../../assets';
import { colors } from '../../../theme';

export const ScrollbarStyled = css`
    ::-webkit-scrollbar {
        width: 12px;
    }

    ::-webkit-scrollbar-track-piece:vertical {
        background-color: ${colors.backgroundColorDisabled};
    }

    ::-webkit-scrollbar-thumb:vertical {
        background: #b1b3b6 url(${icons.scrollbarThumbIcon}) no-repeat center;
        border-radius: 6px;
    }
`;
